import { c as _c } from "react/compiler-runtime";
import type { ComponentPropsWithoutRef, ElementType, ReactNode } from 'react';
import type { LinkProps } from '@mui/material/Link';
import Box from '../Box';
import Typography, { Props as TypographyProps } from '../Typography';
import { styled, SxProps, Theme } from '../styles';
export type Props<C extends ElementType = ElementType> = {
  component?: C;
  to?: string | {
    pathname: string;
    search?: string;
    hash?: string;
  };
  children?: ReactNode;
  startIcon?: ReactNode | null;
  endIcon?: ReactNode | null;
  sx?: SxProps<Theme>;
} & Partial<ComponentPropsWithoutRef<C>> & Omit<LinkProps, 'component' | 'variant' | 'to'>;
const Root = styled(Typography)<TypographyProps>(({
  theme: {
    palette
  }
}) => ({
  textDecoration: 'none',
  display: 'flex',
  alignItems: 'center',
  cursor: 'pointer',
  '&:hover': {
    color: palette.interaction.enabled
  }
}));
const IconContainer = styled(Box)(() => ({
  display: 'inline-flex',
  alignItems: 'center'
}));
const NavLink = t0 => {
  const $ = _c(18);
  let children;
  let component;
  let endIcon;
  let otherProps;
  let startIcon;
  let sx;
  if ($[0] !== t0) {
    ({
      children,
      component,
      sx,
      startIcon,
      endIcon,
      ...otherProps
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = component;
    $[3] = endIcon;
    $[4] = otherProps;
    $[5] = startIcon;
    $[6] = sx;
  } else {
    children = $[1];
    component = $[2];
    endIcon = $[3];
    otherProps = $[4];
    startIcon = $[5];
    sx = $[6];
  }
  let t1;
  if ($[7] !== startIcon) {
    t1 = startIcon && <IconContainer sx={{
      marginRight: 1
    }}>{startIcon}</IconContainer>;
    $[7] = startIcon;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  let t2;
  if ($[9] !== endIcon) {
    t2 = endIcon && <IconContainer sx={{
      marginLeft: 1
    }}>{endIcon}</IconContainer>;
    $[9] = endIcon;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  let t3;
  if ($[11] !== children || $[12] !== component || $[13] !== otherProps || $[14] !== sx || $[15] !== t1 || $[16] !== t2) {
    t3 = <Root component={component} variant="subheading" display="inline" {...otherProps} sx={sx}>{t1}{children}{t2}</Root>;
    $[11] = children;
    $[12] = component;
    $[13] = otherProps;
    $[14] = sx;
    $[15] = t1;
    $[16] = t2;
    $[17] = t3;
  } else {
    t3 = $[17];
  }
  return t3;
};
export default NavLink;